import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Stack, Typography } from '@mui/material';

interface UserStatusBlockingScreenProps {
  status: string;
}

const getStatusContent = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        title: 'Your account is pending activation',
        message:
          'Your account has been created and is awaiting activation.\n\nPlease contact a Superadmin to approve your access.'
      };
    default:
      return {
        title: 'Your account has been deactivated',
        message:
          'Your account has been deactivated.\n\nPlease contact a Superadmin to approve your access.'
      };
  }
};

const UserStatusBlockingScreen: React.FC<UserStatusBlockingScreenProps> = ({
  status
}) => {
  const { logout } = useAuth0();

  const { title, message } = getStatusContent(status);

  const handleLogout = () => {
    logout({
      returnTo: window.location.origin
    });
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: '#FCFEFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        zIndex: 9999
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          width: '100%',
          textAlign: 'center'
        }}
      >
        <Typography color="#0A1E28" fontSize="2rem" fontWeight="bold" mb={3}>
          {title}
        </Typography>

        <Typography
          color="#364955"
          fontSize="1.25rem"
          mb={4}
          sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}
        >
          {message}
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="center">
          <Button
            variant="outlined"
            onClick={handleLogout}
            sx={{ minWidth: 140, height: 48 }}
          >
            Sign Out
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default UserStatusBlockingScreen;
